import { useMemo, useState, useEffect } from 'react';
import { file } from './../data';
import { logger } from './../utils/utils';

/**
 * useThumbnails
 * Hook: image-file thumbnails
 * @return {array} thumbnails
 *
 */
export function useThumbnails(issue_id, commentFiles) {
  // Hook thumbnails **Must memo files (Because files are dependency of useThumbnails)
  logger('useThumbnails render');

  const [data, setData] = useState([]);
  useEffect(() => {
    let files = commentFiles ? commentFiles.split(',') : [];
    file
      .thumbnails({ issue_id, files })
      .then((contents) => {
        setData(contents);
      })
      .catch((error) => {
        console.error('use thumbnail error, ', error);
      });
  }, [commentFiles]);
  return data;
}
